import React from "react";
import { Box, Paper, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import brand from "../../assets/auth/BrainyCare-Logo.jpg";

const NotAllowedPage = () => {
  const navigate = useNavigate();

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100vh"
      sx={{ background: "linear-gradient(to bottom right, #f9fafb, #eef2f7)" }}
    >
      <Paper
        elevation={6}
        sx={{
          p: 5,
          borderRadius: 4,
          maxWidth: 450,
          textAlign: "center",
          backgroundColor: "#fff",
        }}
      >
        {/* Logo */}
        <Box display="flex" justifyContent="center" mb={3}>
          <img src={brand} alt="BrainyCare Logo" style={{ height: 60 }} />
        </Box>

        {/* Title */}
        <Typography
          variant="h5"
          gutterBottom
          sx={{ fontWeight: "bold", color: "#d32f2f" }}
        >
          🚫 Access Denied
        </Typography>

        {/* Subtitle */}
        <Typography
          variant="body1"
          sx={{ color: "#555", mb: 3, lineHeight: 1.6 }}
        >
          You don’t have permission to access this page.  
          Please contact your administrator if you believe this is a mistake.
        </Typography>

        {/* Go Back Button */}
        <Button
          variant="contained"
          color="primary"
          onClick={() => navigate(-1)}
          sx={{
            borderRadius: 3,
            px: 4,
            py: 1,
            textTransform: "none",
            fontWeight: "bold",
            fontSize: "1rem",
          }}
        >
          Go Back
        </Button>
      </Paper>
    </Box>
  );
};

export default NotAllowedPage;
